import * as React from 'react';

export function InfoCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3057 4.50001C7.0993 4.50001 4.50001 7.0993 4.50001 10.3057C4.50001 13.5121 7.0993 16.1114 10.3057 16.1114C13.5121 16.1114 16.1114 13.5121 16.1114 10.3057C16.1114 7.0993 13.5121 4.50001 10.3057 4.50001ZM10.3057 3.00001C6.27087 3.00001 3.00001 6.27087 3.00001 10.3057C3.00001 14.3405 6.27087 17.6114 10.3057 17.6114C14.3405 17.6114 17.6114 14.3405 17.6114 10.3057C17.6114 6.27087 14.3405 3.00001 10.3057 3.00001Z"
      />
      <path
        fill="currentColor"
        d="M9.51214 7.27861C9.51214 6.81896 9.88475 6.44634 10.3444 6.44634C10.804 6.44634 11.1767 6.81896 11.1767 7.27861C11.1767 7.73825 10.804 8.11087 10.3444 8.11087C9.88475 8.11087 9.51214 7.73825 9.51214 7.27861Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3403 8.923C10.7545 8.923 11.0903 9.25879 11.0903 9.673L11.0903 13.4689C11.0903 13.8831 10.7545 14.2189 10.3403 14.2189C9.92606 14.2189 9.59027 13.8831 9.59027 13.4689L9.59027 9.673C9.59027 9.25879 9.92606 8.923 10.3403 8.923Z"
      />
    </svg>
  );
}

export default InfoCircle;
